import Cookies from 'js-cookie';
import { v1 as uuidV1 } from 'uuid';

const CLIENT_UUID_KEY = 'DEVICE_ID';
const COOKIE_EXPIRES_DAYS = 365 * 5;

function isIpAddress(hostname: string): boolean {
    return /^\d{1,3}(?:\.\d{1,3}){3}$/.test(hostname) || hostname.includes(':');
}

function canWriteCookieForDomain(domain: string): boolean {
    if (typeof document === 'undefined') return false;

    const probeKey = `device-id-domain-probe-${Math.random().toString(36).slice(2)}`;
    const cookieOptions = `path=/; domain=${domain}; SameSite=Lax`;
    document.cookie = `${probeKey}=1; ${cookieOptions}`;
    const wasWritten = document.cookie.split('; ').some(cookie => cookie.startsWith(`${probeKey}=`));
    document.cookie = `${probeKey}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${cookieOptions}`;
    return wasWritten;
}

/**
 * Finds the widest cookie domain accepted by the browser without shipping a
 * complete public-suffix database. This preserves cross-subdomain DEVICE_IDs.
 */
export function currentCookieDomain(hostname = window.location.hostname): string {
    if (!hostname.includes('.') || isIpAddress(hostname)) return hostname;

    const labels = hostname.split('.');
    for (let index = labels.length - 2; index >= 0; index -= 1) {
        const candidate = labels.slice(index).join('.');
        if (canWriteCookieForDomain(candidate)) return `.${candidate}`;
    }

    return hostname;
}

export function currentClientUUID(domain?: string): string {
    let clientUUID = Cookies.get(CLIENT_UUID_KEY);
    if (clientUUID) return clientUUID;

    clientUUID = uuidV1();
    Cookies.set(CLIENT_UUID_KEY, clientUUID, {
        expires: COOKIE_EXPIRES_DAYS,
        path: '/',
        domain: domain || currentCookieDomain(),
        sameSite: 'Lax',
    });
    return clientUUID;
}
